// file with config data (different for development and production)
const configData = process.env.NODE_ENV !== 'production' ? require('./data-dev.json') : require('./data-prod.json');

// returns object with config data
const getConfigData = () => {
  return configData;
}

export default getConfigData;



// WEBPACK FOOTER //
// ./src/config/index.js